import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Main from "./Main";
import { Box } from "@mui/material";

const Layout = (props) => {
    return (
        <>
            <Header />
            <Main>
                {props.children}
            </Main>
            <Footer />
        </>
    )
}

export default Layout